import React from 'react';
import MonitorHeartOutlinedIcon from '@mui/icons-material/MonitorHeartOutlined';
import {
  SvgIconProps,
} from '@mui/material/SvgIcon';

export default function VitalsIcon(props: SvgIconProps) {
  return <MonitorHeartOutlinedIcon {...props} />;
}
